import { StateCreator } from "zustand";

export interface MirageLoginState {
    selectedApp: string;
    requestedPath: string;
}

export interface MirageLoginSlice {
    mirageLogin: MirageLoginState;
    setMirageLogin: (state: MirageLoginState) => void;
    updateMirageLogin: (partialState: Partial<MirageLoginState>) => void;
    resetMirageLogin: () => void;
}

const initialMirageLoginState: MirageLoginState = { selectedApp: "", requestedPath: "" };

export const createMirageLoginSlice: StateCreator<MirageLoginSlice, [], [], MirageLoginSlice> = (set) => ({
    mirageLogin: initialMirageLoginState,

    setMirageLogin: (state) => set({ mirageLogin: state }),
    updateMirageLogin: (partialState) => set((state) => ({ mirageLogin: { ...state.mirageLogin, ...partialState } })),
    resetMirageLogin: () => set({ mirageLogin: initialMirageLoginState }),
});

